export default {
  /**
   * Check if user has permission to edit priority, responsible,
   * start dealt, finish dealt or reopen dealt
   */
  hasPermissionToEdit(state, getters, rootState) {
    if (!state.dealt.responsibles) {
      return false;
    }
    for (let i = 0; i < state.dealt.responsibles.length; i++) {
      const responsible = state.dealt.responsibles[i];

      if (responsible.uuid === rootState.profile.profile.uuid) {
        return true;
      }
    }
    return false;
  }
};
